import _extends from "@babel/runtime/helpers/extends";
import { Box } from '@wix/design-system';
import React from 'react';
import { STUDIO_SALE_BG_COLOR, STUDIO_SALE_TEXT_COLOR } from '../../utils/consts';
export const SaleBannerStrip = _ref => {
  let {
    children,
    mobile = false,
    desktopHeight = '40px',
    ...boxProps
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    width: "100%",
    boxSizing: "border-box"
  }, boxProps), /*#__PURE__*/React.createElement(Box, _extends({
    backgroundColor: STUDIO_SALE_BG_COLOR,
    paddingLeft: mobile ? '12px' : '36px',
    paddingRight: mobile ? '12px' : '36px',
    width: "100%"
    // Desktop is a fixed-height strip (regular=40px per Figma 1:15322,
    // last-day with timer=55px). Mobile has two variants with different
    // heights (regular=49px, last-day=69px) so let the inner content's
    // padding determine height.
  }, !mobile && {
    height: desktopHeight
  }, {
    style: {
      color: STUDIO_SALE_TEXT_COLOR
    },
    align: "center",
    verticalAlign: "middle",
    direction: "horizontal",
    boxSizing: "border-box"
  }), children));
};
//# sourceMappingURL=SaleBannerStrip.js.map